<template>
    <section>
        <app-header></app-header>
        <app-banner></app-banner>
        <app-growth></app-growth>
        <app-story></app-story>
        <app-products></app-products>
        <app-organic></app-organic>
        <app-organic-explenation></app-organic-explenation>
        <app-certification></app-certification>
        <app-footer></app-footer>
    </section>
</template>

<script>
import Header from './header.vue'
import Footer from './footer.vue'
import Banner from './index/Banner.vue'
import Growth from './index/Growths.vue'
import Story from './index/Story.vue'
import Products from './index/Products.vue'
import Organic from './index/Organic.vue'
import OrganicExplenation from './index/OrganicExplenation.vue'
import Certification from './index/Certification.vue'
import vWow from 'v-wow'

export default {
        components: { 
            "app-header": Header,
            "app-footer": Footer,
            "app-banner": Banner,
            "app-growth": Growth,
            "app-story": Story,
            "app-products": Products,
            "app-organic": Organic,
            "app-organic-explenation": OrganicExplenation,
            "app-certification": Certification,
            vWow,
        }
}
</script>

